import React, { useContext, useEffect, useState } from 'react'
import { Tree, Checkbox, Input, Select } from 'antd'
import { useStoreActions, useStoreState } from 'easy-peasy'
import { DATA_NEW, DATA_TEST, MENU_DATA, OPTIONS_SELECT_FILTER } from './constant'

// import { flattenChannelChildren } from '../../helpers'
import { RiSearchLine } from 'react-icons/ri'
import { DataNode } from 'antd/lib/tree'
import { dimensionPopupContext } from 'Containers/DimensionFilters/Dimensions.Popup'
import { StoreProps } from 'Models/dimensions'
export interface StoreNode extends DataNode {
  store_code?: string
  storeKey?: string
}
const DimensionsMktChannel = () => {
  const {
    setDimensionsDraft,
    editingDimension,
    setEditingDimension,
    dimensionsDraft,
    quickSelectPhysicalStore,
    setQuickSelect,
  } = useContext(dimensionPopupContext)
  const { physicalStoreGroup } = useStoreState((state) => state.dimensions)
  const [valueSelect, setValueSelect] = useState<string[]>(
    quickSelectPhysicalStore ? quickSelectPhysicalStore : []
  )
  const [data, setData] = useState<StoreNode[] | any>([])
  const [checkedKeys, setCheckedKeys] = useState<string[]>([])
  const [searchText, setSearchText] = useState('')
  const [originalData, setOriginalData] = useState<StoreNode[]>([])
  const [expandKeys, setExpandKeys] = useState<string[]>([])
  const [expandedParents, setExpandedParents] = useState<boolean>(false)
  useEffect(() => {
    if (physicalStoreGroup) {
      const TreeData = physicalStoreGroup[0]?.dimensions[0]?.tree
      setData(TreeData)
      setOriginalData(TreeData)
    }
  }, [physicalStoreGroup])

  useEffect(() => {
    if (dimensionsDraft) {
      let dataSelected: string[] = []
      dimensionsDraft.forEach((dim) => {
        if (dim?.segments[0].type === 'PHYSICAL_STORE') {
          dataSelected = dim?.segments[0].value.split(',')
        }
      })
      setCheckedKeys(dataSelected)
      setExpandKeys(dataSelected)
      setExpandedParents(true)
    }
  }, [dimensionsDraft])

  const onSetDimensions = (value: string[]) => {
    setDimensionsDraft({
      type: 'addChannel',
      payload: {
        dimension: {
          segments: [
            {
              audience_Type: 'audience',
              type: 'PHYSICAL_STORE',
              operator: 'IN_THE_FOLLOWING',
              value: value.toString(),
              time_value: '',
            },
          ],
          condition: dimensionsDraft[1]?.condition || 'AND',
        },
      },
    })
  }

  const FilterData = (condition) => (data) => {
    return data.reduce((acc, obj) => {
      if (obj.children) {
        return [...acc, { ...obj, children: FilterData(condition)(obj.children) }]
      } else if (condition(obj)) {
        return [...acc, obj]
      }
      return acc
    }, [])
  }

  const FilterDataSelected = (condition) => (data) => {
    return data.reduce((acc, obj) => {
      if (obj.children)
        return [...acc, { ...obj, children: FilterDataSelected(condition)(obj.children) }]
      else if (condition(obj)) return [...acc, obj]
      return acc
    }, [])
  }
  const handleExpand = (keys, nodes) => {
    setExpandKeys((prev) => {
      if (nodes.expanded) {
        return [...prev, nodes.node.key]
      } else {
        setExpandedParents(false)
        return prev.filter((item) => item != nodes.node.key)
      }
    })
  }

  let getAllKeys = (tree: any) => {
    let result: any = []
    tree?.forEach((x) => {
      let childKeys = []
      if (x.children) {
        childKeys = getAllKeys(x.children)
      }
      result.push(...[x.key, ...childKeys])
    })
    return result
  }

  const getKeySelect = (tree: any, checkBox: any[]) => {
    let result: any = []
    tree.forEach((item) => {
      let childrenKey = []
      if (item.children) {
        childrenKey = getKeySelect(item.children, checkBox)
      } else {
        if (checkBox.length == 2) {
          result.push(...[item.key, ...childrenKey])
        }
        if (checkBox.length == 1) {
          const value1 = checkBox[0]
          if (value1.includes('mini')) {
            if (item.title.toLowerCase().includes('mini')) {
              result.push(...[item.key, ...childrenKey])
            }
          } else {
            if (item.title.toLowerCase().includes('mart')) {
              result.push(...[item.key, ...childrenKey])
            }
          }
        }
      }
      result.push(...childrenKey)
    })
    return result
  }

  const filterTreeNode = (node: any) => {
    return node?.title?.toLowerCase().includes(searchText.toLowerCase())
  }

  const handleChange = (value) => {
    // console.log(`selected ${value}`)
  }

  const onChangeSearch = (event) => {
    setSearchText(event.target.value)
    if (event.target.value.length > 2) {
      const hasSearchTerm = (n) => n.toLowerCase().includes(event.target.value.toLowerCase())
      const filterData = (arr) =>
        arr?.filter((n) => hasSearchTerm(n.title) || filterData(n.children)?.length > 0)
      const filteredData = filterData(originalData).map((n) => {
        return {
          ...n,
          children: filterData(n.children),
        }
      })
      const getExpandedKeys = (tree: any) => {
        return tree.reduce((acc, obj) => {
          if (obj.children) {
            if (hasSearchTerm(obj.title)) return [...acc, obj.key, ...getExpandedKeys(obj.children)]
            else return [...acc, ...getExpandedKeys(obj.children)]
          } else {
            if (hasSearchTerm(obj.title)) return [...acc, obj.key]
            else return acc
          }
        }, [])
      }
      setData(filteredData)
      setExpandKeys(getExpandedKeys(filteredData))
      setExpandedParents(true)
    } else {
      setData(originalData)
      setExpandKeys(checkedKeys)
      setExpandedParents(checkedKeys ? true : false)
    }
  }

  const onCheck = (e) => {
    const allKeys = [...e.checkedNodes.map((node) => node.key)]
    if (e?.checked === true) {
      setExpandKeys([...allKeys, ...expandKeys])
      setCheckedKeys((prev) => {
        onSetDimensions(allKeys)
        return allKeys
      })
    } else {
      setExpandKeys([...allKeys, ...expandKeys])
      setCheckedKeys((prev) => {
        onSetDimensions(allKeys)
        if (!allKeys.length) {
          dimensionsDraft.map((dimension, index) => {
            if (dimension?.segments[0].type == 'PHYSICAL_STORE') {
              setDimensionsDraft({ type: 'remove', payload: { index } })
            }
          })
        }
        return allKeys
      })
    }
  }

  const handleOnChangeSelect = (e) => {
    setValueSelect((prev) => {
      if (!e.length) {
        dimensionsDraft.map((dimension, index) => {
          if (dimension?.segments[0].type == 'PHYSICAL_STORE') {
            setDimensionsDraft({ type: 'remove', payload: { index } })
          }
        })
        return []
      } else {
        if (e.length > 1) {
          onCheckAll()
        } else {
          const newDataSelected = getKeySelect(data, e)
          setCheckedKeys(newDataSelected)
          setExpandKeys(newDataSelected)
          newDataSelected && setExpandedParents(true)
          onSetDimensions(newDataSelected)
        }

        return e
      }
    })
  }

  const allKeys = getAllKeys(data)
  const onCheckAll = () => {
    if (checkedKeys?.length === allKeys?.length) {
      // setDimensionsDraft({ type: 'clear' })
      dimensionsDraft &&
        dimensionsDraft.map((dimension, index) => {
          if (dimension?.segments[0].type == 'PHYSICAL_STORE') {
            setDimensionsDraft({ type: 'remove', payload: { index } })
          }
        })
      setCheckedKeys([])
    } else {
      setCheckedKeys(allKeys)
      onSetDimensions(allKeys)
    }
  }

  const renderDropdown = (
    <div>
      <Checkbox.Group value={valueSelect} onChange={handleOnChangeSelect}>
        <div className="p-2">
          {OPTIONS_SELECT_FILTER.map((item) => (
            <div
              key={item.value}
              className={`px-3 py-1 ${valueSelect.includes(item.value) ? 'bg-hover_overlay' : ''} `}
            >
              <Checkbox value={item.value}>{item.label}</Checkbox>
            </div>
          ))}
        </div>
      </Checkbox.Group>
    </div>
  )
  return (
    <div className="p-4">
      <div className="flex items-center justify-between">
        <div className="flex-1 mr-4">
          <Input
            onChange={(e) => onChangeSearch(e)}
            value={searchText}
            placeholder="Search"
            prefix={<RiSearchLine />}
          />
        </div>
        <div>
          <Select
            defaultValue="Quick Select"
            style={{
              width: 200,
            }}
            onChange={handleChange}
            dropdownRender={() => renderDropdown}
          />
        </div>
      </div>
      <div className="mt-4 ml-6">
        {!searchText && (
          <Checkbox
            onChange={onCheckAll}
            checked={checkedKeys?.length === allKeys?.length ? true : false}
          >
            <div style={{ marginLeft: 4, fontSize: 16 }}>All</div>
          </Checkbox>
        )}
      </div>
      <div>
        <Tree
          checkedKeys={checkedKeys || undefined}
          expandedKeys={expandKeys}
          autoExpandParent={expandedParents}
          checkable
          onCheck={(keys, nodes) => {
            onCheck(nodes)
          }}
          onExpand={(keys, nodes) => {
            handleExpand(keys, nodes)
          }}
          treeData={data}
          filterTreeNode={filterTreeNode}
        />
      </div>
    </div>
  )
}

export default DimensionsMktChannel
